import { createEffect } from 'effector';
import zoom8hexagons from '../../data/zoom8.json';

export const getZoom8HexagonsFx = createEffect().use(async () => {
  return new Promise((resolve) =>
    setTimeout(() => {
      return resolve(zoom8hexagons);
    }, 1000)
  );
});
